export default __webpack_public_path__ + "static/media/working-with-us-2k.1306732b.jpg";